import $ from 'jquery';
import { EventBus } from '@/app/shared/services/event-bus.js';
import ConfirmPopup from '@/app/shared/components/confirm-popup/confirm-popup.vue';
import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { KendoService } from '@/app/shared/services/kendo-service/kendoService.js';
import config from '@/app/inventory-management/shared/config/inventory-management-config.json'
import { refreshGridAfterDelete } from '@/app/shared/grid-functionality/grid-utilities.js';
import { vendorGroupService } from '@/app/inventory-management/shared/services/purchase-management/vendor-group-service.js';
import { getSaveResultEnums } from '@/app/inventory-management/shared/config/inventory-management-enums.js'
import { getTooltipTilte } from '@/app/shared/grid-functionality/grid-functionality.js';
import Loader from '@/app/shared/layouts/components/loader/loader.vue';

let saveResultEnums = getSaveResultEnums();
import '@progress/kendo-ui/js/kendo.grid';

//Module localization 


localStorage.getItem('NG_TRANSLATE_LANG_KEY') == 'en' ? import('@/app/inventory-management/theme/inventory-management.scss') : import('@/app/inventory-management/theme/inventory-management-rtl.scss');

import localeEn from '../../../../../locales/en'
import localeAr from '../../../../../locales/ar'



let vendorgrouplist = new KendoService(vendorGroupService.getVendorGroup(), config.pageSize, "ID",
    {
        Code: { type: "long" },
        CodeString: { type: "string" },
        EnName: { type: "string" },
        ArName: { type: "string" },
        ParentVendorGroupName: { type: "string" },
        Prefix: { type: "string" },
        IsActive: { type: "boolean" },

    }, "CreatedDate");
export default {
    name: "vendor-group",
    data() {
        return {
            isLoading: false,
            condAdd: this.showHideElement("Add"),
            condEdit: this.showHideElement("Edit"),
            condDelete: this.showHideElement("Delete"),
            datasource: vendorgrouplist.data,
            filterableObject: {
                mode: 'row',
                extra: 'false',
                messages: {
                    search: true
                },
                operators: {
                    string: 'contains'
                }
            },
            editableConfig: {
                confirmation: false,
                destroy: false
            },
            customGridCommand: [
                {
                    name: 'edit',
                    iconClass: {
                        update: "fas fa-check-circle",
                        cancel: "far fa-times-circle"

                    },
                    
                    text: { edit: this.$i18n.t('Common.Edit'), cancel: this.$i18n.t('Common.Cancel'), update: this.$i18n.t('Common.Update') },
                    click: this.clickEditRow,
                    template: `<a role='button' class='k-button k-button-icontext k-grid-edit'> ${this.$i18n.t('Common.Edit')}<img src=${require('@/assets/svg/ic_edit.svg')} /></a>`
                },
                {
                    name: "showConfirmPopup",
                    text: this.$i18n.t('Common.Delete'),
                    iconClass: 'fas fa-trash-alt',
                    click: this.showConfirmPopup,
                    template: () => {
                        return `<a role='button' class='k-button k-button-icontext k-grid-delete k-grid-showConfirmPopup' > ${this.$i18n.t('Common.Delete')} <img src=${require('@/assets/svg/ic_delete.svg')} /></a>`
                    }
                }
            ],
            confirmdata: [
                {
                    confirmText: '',
                    confirmBtnBtnText: '',
                    cancelBtnText: '',
                    headerTitle: '',
                    messageText: '',
                    poptype: '',
                    itemName: '',
                    qmark: '',
                    id: '',
                    modifiedTs: ''
                }
            ],
        }
    },




    components: {
        ConfirmPopup,
        Loader
    },


    mounted() {
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();
        $('.k-filtercell [data-role="autocomplete"] ,.k-filtercell [data-role="numerictextbox"]').attr('placeholder', '');
        EventBus.$on('confirmed-action', (data) => {
            this.isLoading = true;
            vendorGroupService.deleteVendorGroup(data.id, data.modifiedTs, (result) => {
                if (result.data > 0) {
                    this.isLoading = false;
                    switch (result.data) {
                        case parseInt(saveResultEnums.Success):
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Success')}</h6><p>${this.$i18n.t('Common.DeletedSuccessfully')}</p>`, 'success');
                            refreshGridAfterDelete("#vendorGroupGrid");
                            break; 
                        case parseInt(saveResultEnums.Failure):
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.ServerError')}</p>`, 'error')
                            break;
                        case parseInt(saveResultEnums.AssignnedToVendor):
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Inventory.venderGroup.ConfigDeleteVendorGroupMsg')}</p>`, 'warning')
                            break;
                        case parseInt(saveResultEnums.HasChildren):
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Inventory.venderGroup.ConfigDeleteVendorGroupMsg')}</p>`, 'warning')
                            break;
                        case parseInt(saveResultEnums.Concurrency):
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Inventory.venderGroup.VenderGroupDeleted')}</p>`,'warning')
                            refreshGridAfterDelete("#vendorGroupGrid");
                            break;
                    }
                }
            });
        });
        this.condAdd ? $('.k-grid-add').addClass("d-inline-block") : $('.k-grid-add').remove();

    },
    methods: {
        showHideElement(clientAction) {
            return modelServices.ifUserHasPermission(clientAction, this.$route.name);
        },

        showPopupNotification: function (msg, type) {
            this.popupNotificationWidget.show(msg, type);
        },

        ///////////Add form////////////////////////////
        clickAddRow: function () {
             
            this.$store.commit('setIsEditVendorGroup', false)
            this.$store.commit('setVendorGroupId', 0)
        },


        /////////////////////////edit row///

        clickEditRow: function (e) {
            this.isLoading = true;
            let grid = $("#vendorGroupGrid").getKendoGrid();
            let row = grid.dataItem($(e.target).closest("tr"));
            let vendorgroupId = row.ID;
            let param = { vendorGroupId: vendorgroupId };
            vendorGroupService.isVendorGroupDeleted(param).then((response) => {
                if (response.data == false) {
                    this.$store.commit('setIsEditVendorGroup', true)
                    this.$store.commit('setVendorGroupId', vendorgroupId)
                    this.$router.push('/supply-chain/purchase-management/setups/vendor-setup/vendor-group/edit-vendor-group');
                }
                else if (response.data == true) {
                    this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Inventory.venderGroup.VenderGroupDeleted')}</p>`,'warning')
                    refreshGridAfterDelete("#vendorGroupGrid");
                }
                this.isLoading = false;

            });
        },

        ////////////////////filtration dropdown
        statusFilter(args) {
            args.element.kendoDropDownList({
                dataSource: {
                    data: [
                        { text: this.$i18n.t('Common.Active'), value: true },
                        { text: this.$i18n.t('Inventory.WHLocation.InActive'), value: false }
                    ]
                },
                dataTextField: "text",
                dataValueField: "value",
                valuePrimitive: true,
                optionLabel: this.$i18n.t('Common.All'),
                autoWidth: true
            });
        },

        ////////////////////////Load Content of Grid Tooltip if text is longer than td
        getTooltipTilte: e => getTooltipTilte(e),

        ///////////////////////////No data found
        noRecordTemplate: function () {
            return `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFound.svg')} /> <div>${this.$i18n.t('Common.NoDataToDisplay')}</div>`;
        },


        /////////////////////delete toaster////////////////////////

        deleteWarehouseCategory() {
            return this.showPopupNotification(`<h6>${this.$i18n.t('Common.Success')}</h6><p>${this.$i18n.t('Common.DeletedSuccessfully')}</p>`, 'success')
        },

        showConfirmPopup(e) {
            let thisEnName = e.target.parentElement.parentElement.parentElement.childNodes[1].textContent
            let thisArName = e.target.parentElement.parentElement.parentElement.childNodes[2].textContent
            this._bv__modal.show('modal-scoped');
            this.confirmdata.poptype = "warning";
            this.confirmdata.iconName = 'text-danger fas fa-exclamation-triangle';
            this.confirmdata.headerTitle = this.$i18n.t('Common.Alert');
            this.confirmdata.confirmBtnText = this.$i18n.t('Common.No');
            this.confirmdata.cancelBtnText = this.$i18n.t('Common.Yes');
            this.confirmdata.messageText = this.$i18n.t('Common.DeleteMsg');
            this.confirmdata.itemName = localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? `"${thisEnName}"` : `${thisArName}"`;
            this.confirmdata.qmark = this.$i18n.t('Common.QuestionMark');
            let productCategoryObj = this.getProductCategoryByNameFormDS(thisEnName);
            this.confirmdata.id = productCategoryObj.id;
            this.confirmdata.modifiedTs = productCategoryObj.modifiedTs;
        },
        getProductCategoryByNameFormDS(enName) {
              
            let productCategoryObj = null;
            //console.log($("#vendorGroupGrid").data("kendoGrid").dataSource.data())
            var gridData = $("#vendorGroupGrid").data("kendoGrid")._data; 
            for (var i = 0; i <= gridData.length; i++) { 
                if (gridData[i].EnName == enName) {
                    productCategoryObj = { id: gridData[i].ID, modifiedTs: gridData[i].ModifiedTS }
                    break;
                }
            }
            return productCategoryObj;
        },
        onDataBound: function (e) {
            // Translate filteration no data
            let filterCells = e.sender.thead.find('.k-filter-row').find('input');
            filterCells.map((idx, cell) => {
                if ($(cell).data("role") == "autocomplete") {
                    let autocomplete = $(cell).data("kendoAutoComplete")
                    autocomplete.setOptions({
                        suggest: false,
                        delay: 0,
                        clearButton: false
                    })

                    autocomplete.bind("open", function (e) {
                        e.preventDefault();
                    });
                }
            });

            this.condDelete ? $('.k-grid-showConfirmPopup').addClass("d-inline-block") : $('.k-grid-showConfirmPopup').addClass("d-none");
            this.condEdit ? $('.k-grid-edit').addClass("d-inline-block") : $('.k-grid-edit').addClass("d-none");
        },

    },

    beforeDestroy() {
        EventBus.$off('confirmed-action')
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },

};










